var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 650,
    viewBox: "0 0 193 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M586.568 1324.91H467.567C444.158 1324.91 425.182 1305.99 425.182 1282.64V1171.28C425.182 1147.93 444.158 1129.01 467.567 1129.01H502.376C525.784 1129.01 544.76 1110.08 544.76 1086.73V875.801C544.76 852.451 525.784 833.525 502.376 833.525H228.12C204.711 833.525 185.735 814.599 185.735 791.249V603.572C185.735 580.223 166.759 561.295 143.351 561.295H78.428C55.0199 561.295 36.0438 542.367 36.0438 519.019V481.649V358.972C36.0438 335.624 17.0677 316.696 -6.34053 316.696H-57.5219C-80.9302 316.696 -99.9062 297.768 -99.9062 274.419V155.139C-99.9062 131.791 -80.9302 112.863 -57.5219 112.863H69.6745C93.0824 112.863 112.058 93.9352 112.058 70.5866V-0.754883",
    stroke: "url(#paint0_linear_9220_8931)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9220_8931",
    x1: 243.331,
    y1: -0.754883,
    x2: 243.331,
    y2: 1324.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BDA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A4BC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthline);
export default __webpack_public_path__ + "static/media/healthline.e6e247427ce6d84ad42b0f0e226567b3.svg";
export { ForwardRef as ReactComponent };